// extracted by mini-css-extract-plugin
export default {"companies":"style_companies__eGyfF","companiesSwiper":"style_companiesSwiper__arYjk"};